import { useEffect, useRef } from 'react'

/**
 * Delay in milliseconds or 'disable-timer' to disable countdown
 */
export type CountdownDelay = number | 'disable-timer'

export type UseTimerOptions = {
  delay?: CountdownDelay
  onTick: () => void
}

export default function useTimer(
  { delay = 1000, onTick }: UseTimerOptions,
  deps?: React.DependencyList,
) {
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null)

  const initTimer = () => {
    if (delay !== 'disable-timer') {
      tryStopTimer()
      timerRef.current = setInterval(onTick, delay)
    }
  }

  const tryStopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current)
    }
  }

  useEffect(() => {
    initTimer()
    return tryStopTimer
  }, deps)
}
